/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, Tabs as TabContainer } from "@nordcloud/gnui";
import { StyledTab } from "~/components/Styled/Tabs";
import { useTabStepNavigation } from "~/hooks";
import { MetadataTab } from "./Metadata/Metadata";

const TAB_STEP_MAPPING: Record<string, number> = {
  details: 0,
  metadata: 1,
};

export function Tabs({ detailsTab }: { detailsTab: JSX.Element }) {
  const { currentStep, handleTab } = useTabStepNavigation(TAB_STEP_MAPPING);

  return (
    <Box spacing="spacing02" css={{ padding: 0 }}>
      <TabContainer step={currentStep} handleTab={handleTab}>
        <StyledTab heading="Details">{detailsTab}</StyledTab>
        <StyledTab heading="Metadata">
          <MetadataTab />
        </StyledTab>
      </TabContainer>
    </Box>
  );
}
